import { ref } from 'vue'
import GLOBAL from '../../utils/GLOBAL'

export const lang = ref(GLOBAL.generateObjFilter()?.lang || 'pt-BR')
